import React from 'react';
import { Message, CheckboxProps } from 'semantic-ui-react';

import WarningMessage from '@modules/common/components/banners/WarningMessage';
import TargetBlankLink from '@src/components/common/TargetBlankLink';
import { styled } from '@modules/common/components/ThemeProvider/utils';
import config from '@config/config';
import Checkbox from '@modules/common/components/Checkbox';

type Props = {
  hasAcceptedSPARisk?: boolean;
  setHasAcceptedSPARisk?: (value: boolean) => void;
};

function Warning({ hasAcceptedSPARisk, setHasAcceptedSPARisk }: Props) {
  return (
    <WarningMessage>
      <Message.Header>
        Using client credentials in a frontend application is dangerous!
      </Message.Header>
      <p>
        Your client ID and secret will be exposed to all visitors of your application. Proceed with
        this approach only if you're confident that your credentials will not be misused by any of
        your visitors.{' '}
        <TargetBlankLink href="https://www.ietf.org/archive/id/draft-ietf-oauth-browser-based-apps-15.html#name-client-authentication">
          Learn more.
        </TargetBlankLink>
      </p>

      {setHasAcceptedSPARisk && (
        <StyledCheckbox>
          <Checkbox
            label="I understand the risks and I wish to proceed anyway."
            checked={hasAcceptedSPARisk}
            onChange={(_: any, data: CheckboxProps) => setHasAcceptedSPARisk(Boolean(data.checked))}
          />
        </StyledCheckbox>
      )}
    </WarningMessage>
  );
}

export default Warning;

const StyledCheckbox = styled('p')`
  display: flex;
  flex-direction: row;

  .checkbox > label {
    color: ${config.terciaryTextColor} !important;
    font-weight: 700 !important;
    font-size: 16px;
  }
`;
